import { type } from 'arktype';

const MediaItem = type({
  id: 'number',
  'alt?': 'string | null',
  aspect_ratio: 'number',
  height: 'number',
  width: 'number',
  media_type: 'string',
  position: 'number.integer',
  src: 'string',
});

const VariantItem = type({
  available: 'boolean',
  barcode: 'string | null',
  compare_at_price: 'number',
  featured_image: 'string | null',
  id: 'number.integer',
  inventory_management: 'unknown | null',
  option1: 'string | null',
  option2: 'string | null',
  option3: 'string | null',
  options: 'string[]',
  price: 'number.integer',
  public_title: 'string | null',
  'quantity_rule?': type({ min: 'number.integer', max: 'null | number.integer', increment: 'number' }),
  sku: 'string',
});

export const SearchProductItem = type({
  id: 'number',
  title: 'string',
  handle: 'string',
  description: 'string',
  published_at: 'string.date',
  created_at: 'string.date',
  vendor: 'string',
  type: 'string',
  tags: 'string[]',
  price: 'number',
  price_min: 'number',
  price_max: 'number',
  available: 'boolean',
  price_varies: 'boolean',
  compare_at_price: 'number',
  compare_at_price_min: 'number',
  compare_at_price_max: 'number',
  compare_at_price_varies: 'boolean',
  variants: VariantItem.array(),
  images: 'string[]',
  featured_image: 'string',
  options: 'string[]',
  media: MediaItem.array(),
  content: 'string',
});
export const SearchProductItems = type(SearchProductItem.array());

export type SearchProductItem = typeof SearchProductItem.infer;
export type SearchProductItems = SearchProductItem[];
